const pagePercentageMapper = {
    vehicle: 4,
    "vehicle-damage": 16,
    estimate: 28,
    "service-zip": 32,
    "vin-lookup": 32,
    "license-plate-lookup": 32,
    "address-lookup": 32,
    "address-vehicles": 36,
    "part-questions": 40,
    "molding-questions": 40,
    "vehicle-parts": 40,
    "capability-questions": 40,
    quote: 48,
    "insurance-company": 52,
    "service-location": 60,
    schedule: 72,
    "customer-details": 84,
    "payment-method": 92,
    payment: 96,
    confirmation: 100,
};

export const getProgressBarPercentage = (page) => {
    return pagePercentageMapper[page] || 0;
};
